import {
    SHIP_TYPE_LIST_GET,
    SHIP_TYPE_LIST_GET_F,
    SHIP_TYPE_LIST_GET_R,
    SHIP_TYPE_SELECTED_SET
} from '../actionType'

const initialState = {
    ship_types: [],
    isLoading: false,
    error: null,
    totalPage: 0,
    totalElement: 0,
    selectedShipType: null,
}

export default function shipTypeReducer (state = initialState, action : any)  {
    switch (action.type) {
        case SHIP_TYPE_LIST_GET:
            return {
            ...state,
            isLoading: true,
            error: null
            }
        case SHIP_TYPE_LIST_GET_F:
            // console.log('action called')
            // console.log(action.payload.content,'content')
            return {
                ...state,
                isLoading: false,
                ship_types: action.payload.content,
                totalPage: action.payload.total_page,
                totalElement: action.payload.total_element
            }
        case SHIP_TYPE_LIST_GET_R:
            
            return {
                ...state,
                isLoading: false,
                error: action.payload
            }
        case SHIP_TYPE_SELECTED_SET:
            return {
                ...state,
                selectedShipType: action.payload
            }
        default:
            return state
    }
}